import BaseServiceHttp from '../baseService'
class Exportacao extends BaseServiceHttp {
  constructor(id) {
    const resource = 'exportacao'
    const relationship = {
      converterRsumoTxt: 'converter-resumo-txt'
    }
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }

  show(filter) {
    return this._http.get('exportacao/converter-resumo-txt', {
      params: filter,
      responseType: 'arraybuffer'
    })
  }
}

export default id => new Exportacao(id)
